import {COMMUNICATION_TEMPLATE, COMMUNICATION_TYPE} from "../../service/communicationService";

export const COMMUNICATION_TYPE_OPTIONS = [
  { label: 'SMS', value: COMMUNICATION_TYPE.SMS },
  { label: 'Email', value: COMMUNICATION_TYPE.EMAIL },
  { label: 'WhatsApp', value: COMMUNICATION_TYPE.WHATSAPP }
];

export const COMMUNICATION_TEMPLATE_OPTIONS = [
  { label: 'Log in', value: COMMUNICATION_TEMPLATE.COGNITO_AUTH },
  { label: 'Document - Expires In Days', value: COMMUNICATION_TEMPLATE.TASK_DOCUMENT_EXPIRES_IN_DAYS },
  { label: 'Document - Expired', value: COMMUNICATION_TEMPLATE.TASK_DOCUMENT_EXPIRED },
  { label: 'Document - Expired Days Ago', value: COMMUNICATION_TEMPLATE.TASK_DOCUMENT_EXPIRED_DAYS_AGO }
];
